/* eslint-disable no-useless-escape */
import { call, put, takeEvery } from 'redux-saga/effects';
import * as url from '../../helpers/url_helper';
import { dashboardHLTypes } from './actionTypes';

import {
  getTokenIframeSuccess,
  getTokenIframeFail,
} from './actions';


const fetchGetToken = async () => {
  const path = url.API_URL;

  let user;

  const getAuthUser = localStorage.getItem('authUser');

  if (getAuthUser) user = JSON.parse(getAuthUser);
  const query = `query {
	GetJwtDashboardHollistics(
    userId:${user.id}
  ){
    token
  }
}`;

  const response = await fetch(path, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
  }).then((res) => res.json());

  return response?.data?.GetJwtDashboardHollistics?.token;
}

function* GetTokenDashboardHL() {
  try {
    const response: Promise<any> = yield call(fetchGetToken);
    yield put(getTokenIframeSuccess(response));
  } catch (error) {
    yield put(getTokenIframeFail(error));
  }
}

const fetchGenericGetToken = async ({ secretKey, filters, permissions }: any) => {
  const path = url.API_URL;
  let user;
  const getAuthUser = localStorage.getItem('authUser');
  if (getAuthUser) user = JSON.parse(getAuthUser);
  const query = `
  query {
    GetGenericJwtHollistics(
      userId:${user.id}
      secretKey:"${secretKey}",
      filters: "${filters.replace(/\"/g, "'")}"
      permissions: "${permissions.replace(/\"/g, "'")}"
    )
    {
      token
    }
  }`;

  const response = await fetch(path, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
  }).then((res) => res.json());

  return response?.data?.GetGenericJwtHollistics?.token;
}

function* GetGenericTokenDashboardHL({ payload }: any) {
  try {
    const response: Promise<any> = yield call(fetchGenericGetToken, payload);
    yield put(getTokenIframeSuccess(response));
  } catch (error) {
    yield put(getTokenIframeFail(error));
  }
}

function* dashboardHLSaga() {
  yield takeEvery(dashboardHLTypes.GET_TOKEN_IFRAME, GetTokenDashboardHL);
  yield takeEvery(dashboardHLTypes.GET_GENERIC_TOKEN_IFRAME, GetGenericTokenDashboardHL);
}

export default dashboardHLSaga;
